export default __webpack_public_path__ + "static/media/Hanu.e955e82d.png";